import { Box, Button, Drawer, DrawerContent, DrawerOverlay, Heading, Text, useDisclosure, VStack } from '@chakra-ui/react'
import React from 'react'
import { BsArrowRight, BsChevronRight } from 'react-icons/bs'

function DrawerResources() {
    const { isOpen, onOpen, onClose } = useDisclosure()

  return (
    <>
        <Button   variant="link" size="md" colorScheme="black" onMouseEnter={onOpen}>
          Resources
        </Button>
        <Drawer
          size="md"
          isOpen={isOpen}
          placement='left'
          onClose={onClose}
        >
          <DrawerOverlay />
          <DrawerContent>
            <Box overflowY="scroll" p="1rem">
                <VStack spacing={"4rem"} align='stretch'>
                  <Box>
                    <VStack spacing={"1.5rem"} align='stretch'>
                      <Text>LEARN —</Text>
                      <Heading _hover={{color:"teal", cursor:"pointer"}} as="h1"  size="lg" fontWeight="400">Mailchimp 101</Heading>
                      <Heading _hover={{color:"teal", cursor:"pointer"}} as="h1"  size="lg" fontWeight="400">Help Center</Heading>
                      <Box _hover={{color:"teal", cursor:"pointer"}} display="flex" alignItems="center" justifyContent="space-between">
                        <Heading as="h1"  size="lg" fontWeight="400">Marketing Library</Heading>
                        <BsChevronRight fontSize="30px"/>
                      </Box>
                    </VStack> 
                  </Box>
                  <Box>
                    <VStack spacing={"1.5rem"} align='stretch'>
                      <Text>COMMUNITY —</Text>
                      <Box _hover={{color:"teal", cursor:"pointer"}} display="flex" alignItems="center" justifyContent="space-between">
                        <Heading as="h1"  size="lg" fontWeight="400">For Freelancers & Agencies</Heading>
                        <BsChevronRight fontSize="30px"/>
                      </Box>
                      <Box  _hover={{color:"teal", cursor:"pointer"}}display="flex" alignItems="center" justifyContent="space-between">
                        <Heading as="h1"  size="lg" fontWeight="400">For Developers</Heading>
                        <BsChevronRight fontSize="30px"/>
                      </Box>
                      <Heading _hover={{color:"teal", cursor:"pointer"}} as="h1"  size="lg" fontWeight="400">Hire A Trusted Partner</Heading>
                    </VStack> 
                  </Box>
                  <Box>
                    <VStack spacing={"1.5rem"} align='stretch'>
                      <Heading _hover={{color:"teal", cursor:"pointer"}} as="h1"  size="lg" fontWeight="400">Talk to Sales: +1 (800) 315-5939</Heading>
                    </VStack>
                  </Box>
                  <Box>
                    <VStack spacing={"1.5rem"} align='stretch'>
                      <Heading as="h5" fontSize="20px" fontWeight="medium">App Integrations</Heading>
                      <Text>Connect your digital tools so you can do more with your marketing.</Text>
                      <Box w="30%" display="flex" justifyContent="space-between" alignItems="center">
                        <Button colorScheme='teal' variant='link'>See all integrations</Button>
                        <BsArrowRight fontSize="20px" color="teal"/>
                      </Box>
                    </VStack>
                  </Box>
                  </VStack>
            </Box>
          </DrawerContent>
        </Drawer>
    </>
  )
}

export default DrawerResources